import {Injectable} from '@angular/core';
import {PlanTransformation} from '@mydocma/bim-viewer';
import {Point} from 'leaflet';
import {BimSectionPlan, BimPoint, BimSection} from '../../../bp-common/models/plan';
import {PlanService, TileViewerReadyEvent} from '@mydocma/tile-viewer';
import {ViewerReadyParams} from '@mydocma/bim-viewer';

@Injectable()
export class CoordinatesTransformationService {
  private planReady: TileViewerReadyEvent;
  private bimViewerReady: ViewerReadyParams;
  private bimPlan: BimSectionPlan;
  private section: BimSection;

  attach(planReady: TileViewerReadyEvent, bimViewerReady: ViewerReadyParams, {bimPlan, section}) {
    this.planReady = planReady;
    this.bimViewerReady = bimViewerReady;
    this.bimPlan = bimPlan;
    this.section = section;
  }

  public getPlanTransformation(): PlanTransformation {
    this.bimPlan.transform.plan1Point1.z = this.section.level;
    this.bimPlan.transform.plan1Point2.z = this.section.level;

    return {
      versionId: this.bimPlan.versionId,
      planId: this.bimPlan.planId,
      referencePoint1: this.createPlanTransformationPoint(this.bimPlan.transform.plan1Point1, this.bimPlan.transform.plan2Point1),
      referencePoint2: this.createPlanTransformationPoint(this.bimPlan.transform.plan1Point2, this.bimPlan.transform.plan2Point2)
    };

  }

  public transformToModelCoordinates(point: Point) {
    return this.bimViewerReady.coordinatesTransformationService.transformToModelCoordinates(
      new THREE.Vector3(point.x, point.y),
      this.getPlanTransformation()
    );
  }

  public transformToPlanCoordinates(point: BimPoint) {
    return this.bimViewerReady.coordinatesTransformationService.transformToPlanCoordinates(
      point,
      this.getPlanTransformation()
    );
  }

  public relativeToProject(point: Point) {
    const planService = this.planReady.mapService as PlanService;
    const geoCords = planService.getMapCoordinates(point.x, point.y);
    return planService.map.project(geoCords, planService.plan.maxZoom);
  }

  public projectToRelative(point: Point) {
    const planService = this.planReady.mapService as PlanService;
    const georCoords = planService.map.unproject(point, planService.plan.maxZoom);
    return planService.geoMapToPinSystemCoordinates(georCoords);
  }

  private createPlanTransformationPoint(planPoint1, planPoint2): { fromPoint: Point, toPoint: BimPoint } {
    //relatie to project coords
    return {
      fromPoint: this.relativeToProject(planPoint2),
      toPoint: {...planPoint1, z: this.section.level}
    };
  }
}
